






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Document {
    type: string;
}

@Component({ components: { SimpleText } })
export default class DocumentType extends Vue {
    @Prop() public document!: Document;

    public static getNeededFields(): string[] {
        return [];
    }
}
